import React from "react"

import enEnum from "../../locales/en-gb/translation.enum.json" with {type: "json"}
import {TOption} from "../components/formElements/Dropdown/types"
import {i18n} from "../i18n"
import {enumOrders} from "./enumOrders.ts"
import {getNodeText} from "./getNodeText.ts"

export type TTranslatedEnums = typeof enEnum

export function enumTranslKey<
  TEnumName extends keyof TTranslatedEnums,
  TEnumValue extends (keyof TTranslatedEnums[TEnumName] & string) | string,
>(enumName: TEnumName, enumValue: TEnumValue) {
  return `enum:${enumName}_${enumValue}` as const
}

export function enumToOptions<Enum extends keyof TTranslatedEnums>(
  enumName: Enum,
  randSort: boolean = false
): Array<TOption<keyof TTranslatedEnums[Enum] & string>> {
  const unsorted = (Object.keys(enEnum[enumName]) as Array<keyof TTranslatedEnums[Enum] & string>).map(enumValue => {
    return {
      value: enumValue,
      title: i18n.t(enumTranslKey(enumName, enumValue)),
    }
  })

  if (randSort) {
    return unsorted
  }

  return sortEnumOptions(enumName, unsorted)
}

export const sortEnumOptions = <Enum extends keyof TTranslatedEnums>(
  enumName: Enum,
  enumOptions: Array<TOption<keyof TTranslatedEnums[Enum] & string>>
): Array<TOption<keyof TTranslatedEnums[Enum] & string>> => {
  const order = enumOrders[enumName]

  return [...enumOptions].sort((A, B) => {
    return order ? order[A.value] - order[B.value] : getNodeText(A.title).localeCompare(getNodeText(B.title))
  })
}

export const commonTransComponents = {
  bold: <strong className={"font-semibold"} />,
  br: <br />,
  p: <p />,
  item: <span />,
}

export const BulletedTransList: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <div className={"grid grid-cols-[min-content_auto] items-baseline gap-x-3 gap-y-2"}>{children}</div>
}

export function removeTransTags(phrase: string, variables: {[key: string]: string} = {}): string {
  let result = phrase.replaceAll(/<\/?\w+ ?\/?>/g, "")

  for (const [key, value] of Object.entries(variables)) {
    result = result.replace(`{{${key}}}`, value)
  }

  return result
}
